// utils/notifyAudio.js

let dingEl = null;
let audioReady = false;
let audioUnlocked = false;

// инициализация единожды
function ensureAudio() {
    if (dingEl) return dingEl;
    dingEl = new Audio("/sounds/ding.mp3");   // файл должен лежать в public/sounds/ding.mp3
    dingEl.preload = "auto";
    dingEl.volume = 1.0;
    dingEl.addEventListener("canplaythrough", () => { audioReady = true; }, { once: true });
    dingEl.addEventListener("error", (e) => {
        console.warn("⚠️ Не удалось загрузить /sounds/ding.mp3. Проверь путь и доступ.", e);
    });
    // пробуем начать загрузку
    try { dingEl.load(); } catch { }
    return dingEl;
}

// разблокировка аудио-политики Chrome после первого юзерского действия
if (typeof window !== "undefined") {
    const unlock = () => {
        if (audioUnlocked) return;
        try {
            const Ctx = window.AudioContext || window.webkitAudioContext;
            if (Ctx) {
                const ctx = new Ctx();
                const osc = ctx.createOscillator();
                const gain = ctx.createGain();
                gain.gain.value = 0.0001;   // почти тише нуля
                osc.connect(gain).connect(ctx.destination);
                osc.start(0);
                osc.stop(0.01);
                ctx.resume?.();
            }
            audioUnlocked = true;
            console.log("🔊 AudioContext разблокирован");
        } catch { }
        window.removeEventListener("click", unlock);
        window.removeEventListener("keydown", unlock);
    };
    window.addEventListener("click", unlock, { once: true });
    window.addEventListener("keydown", unlock, { once: true });
}

export const playDing = () => {
    const el = ensureAudio();
    // если предыдущий звук ещё играет — вернёмся к началу и проиграем снова
    try {
        el.currentTime = 0;
    } catch { }
    el.play().catch((err) => {
        console.warn("🔇 Браузер отклонил воспроизведение ding:", err);
    });
};

export const speak = (text) => {
    const synth = window.speechSynthesis;
    if (!synth) return;
    const utter = new SpeechSynthesisUtterance(text);
    utter.lang = "ru-RU";
    utter.rate = 1;
    try { synth.speak(utter); } catch (e) { console.warn("TTS error", e); }
};
